import { styled } from 'parkdepot-shared/theme'

export const Wrapper = styled('div', ({ $theme }) => ({
    backgroundColor: $theme.colors.white,
    paddingLeft: '0.8rem',
    marginBottom: '2rem'
}))

export const CardBody = styled('div', () => ({
    display: 'flex',
    justifyContent: 'space-between'
}))

export const CarIcon = styled('i', ({ $theme }) => ({
    fontSize: '2.4rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
}))

export const RightIcon = styled('i', ({ $theme }) => ({
    fontSize: '1.6rem',
    color: $theme.colors.primary,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
}))

export const BodyWrapper = styled('div', () => ({
    cursor: 'pointer',
    display: 'flex',
    gap: '1.6rem'
}))

export const FlexContainer = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    display: 'flex',
    flexDirection: 'column'
}))

export const PlateText = styled('span', () => ({
    fontWeight: 700,
    lineHeight: '2.2rem'
}))

export const IconsContainer = styled('div', () => ({
    display: 'flex',
    gap: '2.4rem'
}))
